import { KumanuKeyType } from '@kp/dialogue/models/dialogue.model';
import { Page } from '@kp/question-set/models/page.model';
import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class QuestionSet implements Deserializable<any, QuestionSet>, Serializable<JsonObject> {
  constructor(
    public id?: string,
    public type?: string,
    public deviceCreatedTimestamp?: string,
    public deviceCompletedTimestamp?: string,
    public createdLocation?: string,
    public key?: string,
    public pages?: Page[],
    public keyType?: KumanuKeyType,
    public isPulseSurvey?: boolean
  ) {}

  get completedDate() {
    if (this.deviceCompletedTimestamp) {
      return new Date(this.deviceCompletedTimestamp);
    }
  }

  get hasAnswers() {
    return this.pages.some((page) => page.questions.some((question) => question.hasAnswer));
  }

  isLastPage(currentPage: number) {
    return this.pages?.[currentPage + 1] == null;
  }

  deserialize(input: any): QuestionSet {
    if (input == null) {
      return null;
    }
    this.id = input.id;
    this.type = input.type;
    this.deviceCreatedTimestamp = input.deviceCreatedTimestamp;
    this.deviceCompletedTimestamp = input.deviceCompletedTimestamp;
    this.createdLocation = input.createdLocation;
    this.key = input.logicKey || input.refKey;
    this.pages = input.pages?.map((page) => new Page().deserialize(page));
    this.keyType = input.keyType as KumanuKeyType;
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['id'] = this.id;
    json['type'] = this.type;
    json['deviceCreatedTimestamp'] = this.deviceCreatedTimestamp;
    json['deviceCompletedTimestamp'] = this.deviceCompletedTimestamp;
    json['createdLocation'] = this.createdLocation;
    json['key'] = this.key;
    json['pages'] = this.pages.map((page) => page.serialize());
    json['keyType'] = this.keyType;
    return json;
  }
}
